export const maps = {
    instance: null,
    promise: new Promise((resolve) => {
        const script = document.createElement('script')
        script.src =
            'https://maps.googleapis.com/maps/api/js?key=AIzaSyBCq5hqIV9Yk1dZ7IsJeEueAxk2Fu4xqNA&libraries=geometry,places&callback=Function.prototype'
        script.async = true
        script.defer = true
        script.onload = function () {
            maps.instance = google.maps
            resolve(maps.instance)
        }
        document.head.appendChild(script)
    }),
}
